import Vue from "vue";
import App from "./App.vue";
import router from "./core/services/router";
import store from "./core/services/store";
import vuetify from "./core/plugins/vuetify";
import i18n from "./core/plugins/i18n";
import "./core/services/pwa/registerServiceWorker";
import "./core/plugins/axios";
import "./core/plugins/datePicker";
import "./core/plugins/highcharts";
import { VueMaskDirective } from "v-mask";
import apiService from "./core/services/api/api.service";
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";

Vue.config.productionTip = false;

apiService.setStore(store);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

Vue.directive("mask", VueMaskDirective);
